module.exports = {
  "country": "RO",
  "artist": "Ovi, Paula Seling",
  "song": "Playing with Fire",
  "year": "2010",
  "place": "3",
  "spotify": "0m3mkj4WTHkfrmHB6toUIK"
};